module.exports = require("remarkable");